import React, { useEffect } from 'react';
import db from './libs/data-base'
import 'bootstrap/dist/css/bootstrap.min.css'
import {Button} from 'react-bootstrap';
import item from './libs/pedidos'
import Pedidos from './components/Pedidos'

const MeusPedidos = () => {

  return (
    <div className="page-main">
    <Pedidos />
    </div>
  );
}

export default MeusPedidos;
